import React, { Component } from "react";

import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
import { } from "../../store/actions";

//Simple bar
import SimpleBar from "simplebar-react";

import SidebarContent from "./SidebarContent";
import withRouter from "../Common/withRouter";
import { Button } from "reactstrap";


class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.type === "condensed" && this.props?.layout.currentWidth <= 768 ?
                        <></> :
                        <div className="vertical-menu">
                            <div className="h-100" onMouseEnter={() => { this.props?.type === "condensed" && this.props?.toggleMenuCallback() }} onClick={() => { this.props.isMobile && this.props?.type === "condensed" && this.props?.toggleMenuCallback() }}>
                                <SimpleBar style={{ height: "100%" }}>
                                    <SidebarContent isMobile={this.props?.layout.currentWidth <= 768}
                                        toggleMenuCallback={this.props.toggleMenuCallback}
                                        type={this.props.type}
                                    />
                                </SimpleBar>
                            </div>
                        </div>
                }

            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return {
        layout: state.Layout
    };
};
export default connect(mapStatetoProps, {})(withRouter(Sidebar));
